
export const products = [

  {
    category: "aeration-equipment",
    categoryName: "Aeration Equipment",
    items: [
      {
        slug: "blowers",
        name: "Blowers",
        image: "/images/products/air-blower.png",
        shortDesc:
          "High-performance industrial blowers for aeration and wastewater treatment applications.",
        description:
          "Sera Water supplies energy-efficient industrial blowers designed for aeration systems in Effluent Treatment Plants (ETP) and Sewage Treatment Plants (STP). Our blowers ensure consistent airflow, low power consumption and reliable performance for wastewater treatment and industrial processes.",

        applications: [
          "Effluent Treatment Plants (ETP)",
          "Sewage Treatment Plants (STP)",
          "Aeration Systems",
          "Industrial Wastewater Treatment",
        ],
        features: [
          "Energy-efficient operation",
          "Low noise and vibration",
          "Continuous duty design",
          "Long service life",
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },
      {
        slug: "disc-diffusers",
        name: "Disc Diffusers",
        image: "/images/products/disc-diffusers.jpg",
        shortDesc:
          "Energy-efficient disc diffusers for fine bubble aeration in wastewater treatment plants.",
        description:
          "Disc diffusers are designed to deliver fine bubble aeration, ensuring maximum oxygen transfer efficiency. Ideal for STP and ETP applications, they help reduce power consumption while maintaining optimal biological treatment performance.",
        applications: [
          "Sewage Treatment Plants (STP)",
          "Effluent Treatment Plants (ETP)",
          "Industrial Wastewater Treatment",
          "Biological Aeration Systems",
        ],
        features: [
          "High oxygen transfer rate",
          "Low pressure drop",
          "Uniform air distribution",
          "Corrosion-resistant materials",
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },
      {
        slug: "tubular-diffusers",
        name: "Tubular Diffusers",
        image: "/images/products/tubular-diffusers.jpg",
        shortDesc:
          "High-efficiency tubular diffusers designed for uniform air distribution in wastewater treatment systems.",
        description:
          "Tubular diffusers are widely used in aeration tanks of wastewater treatment plants to provide efficient oxygen transfer and uniform air distribution. These diffusers improve biological treatment efficiency, reduce energy consumption, and ensure consistent aeration performance in ETP and STP applications.",
        applications: [
          "Municipal Sewage Treatment Plants",
          "Industrial Effluent Treatment Plants",
          "Aeration Tanks",
          "Biological Treatment Systems",
        ],
        features: [
          "High oxygen transfer efficiency",
          "Durable EPDM membrane construction",
          "Uniform air distribution",
          "Low maintenance and long service life",
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },
      {
        slug: "mbbr-media",
        name: "MBBR Media",
        image: "/images/products/MBBR-Media.jpg",
        shortDesc:
          "Advanced MBBR media for biological wastewater treatment processes.",
        description:
          "MBBR (Moving Bed Biofilm Reactor) media provides high surface area for microbial growth, enhancing biological treatment efficiency in sewage and effluent treatment plants. It improves pollutant removal and system stability.",
        applications: [
          "Municipal Wastewater Treatment",
          "Industrial Effluent Treatment",
          "Biological Reactors",
          "Upgradation of Existing STPs",
        ],
        features: [
          "High biofilm surface area",
          "Excellent mechanical strength",
          "Long service life",
          "Improves treatment efficiency",
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },
      {
        slug: "acoustic-hoods",
        name: "Acoustic Hoods",
        shortDesc:
          "Noise reduction acoustic enclosures for blowers, pumps and industrial equipment.",
        image: "/images/products/acoustic-hoods.png",
        description:
          "Sera Water provides acoustic hoods designed to significantly reduce noise levels generated by industrial equipment such as blowers and pumps. Our acoustic enclosures ensure compliance with noise regulations while maintaining proper ventilation and easy access for maintenance.",
        applications: [
          "Blowers & Compressors",
          "Pumps & Motors",
          "Industrial Plants",
          "Noise Control Applications",
        ],
        features: [
          "Excellent noise attenuation",
          "Durable and corrosion-resistant panels",
          "Easy installation & access",
          "Custom design options available",
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },
      {
        slug: "spare-parts",
        name: "Spare Parts / Accessories",
        shortDesc:
          "Genuine spare parts and accessories for water and wastewater treatment equipment.",
        image: "/images/products/spare-parts.png",
        description:
          "We supply a wide range of genuine spare parts and accessories for blowers, pumps, sludge dewatering machines and other water treatment equipment. Our spare parts ensure optimal performance, reduced downtime and extended equipment life.",
        applications: [
          "ETP, STP & WTP Plants",
          "Maintenance & Repair",
          "Industrial Equipment Servicing",
        ],
        features: [
          "Original & compatible spare parts",
          "Improved equipment lifespan",
          "Quick availability",
          "Reliable after-sales support",
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },
    ],
  },

  {
    category: "sludge-handling",
    categoryName: "Sludge Handling Systems",
    items: [
      {
        slug: "centrifuge-machine",
        name: "Centrifuge Machine",
        image: "/images/products/centrifuge.png",
        shortDesc:
          "High-speed centrifuge machines designed for efficient solid-liquid separation in industrial applications.",
        description:
          "Our centrifuge machines are engineered to deliver high-performance separation of solids and liquids using centrifugal force. Widely used in wastewater treatment, chemical processing, pharmaceuticals, and food industries, these machines ensure efficient dewatering, reduced sludge volume, and reliable continuous operation.",
        applications: [
          "Effluent Treatment Plants (ETP)",
          "Sewage Treatment Plants (STP)",
          "Chemical & Pharmaceutical Industries",
          "Food & Beverage Processing Units",
        ],
        features: [
          "High-speed centrifugal separation",
          "Continuous and automatic operation",
          "Low maintenance and high reliability",
          "Compact design with energy efficiency",
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },
      {
        slug: "filter-press",
        name: "Filter Press",
        image: "/images/products/fliterpress.png",
        shortDesc:
          "Efficient solid-liquid separation system for sludge dewatering and wastewater treatment.",
        description:
          "Filter press systems are widely used for effective solid-liquid separation in industrial wastewater treatment processes. Designed for high filtration efficiency, our filter presses help reduce sludge volume, improve cake dryness, and ensure cost-effective waste management across multiple industries.",
        applications: [
          "ETP & STP Plants",
          "Chemical & Pharmaceutical Industries",
          "Food Processing Units",
          "Metal Finishing & Electroplating Industries",
        ],
        features: [
          "High filtration efficiency",
          "Low moisture content in sludge cake",
          "Robust and durable construction",
          "Easy operation and maintenance",
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },
      {
        slug: "sludge-dewatering",
        name: "Sludge Dewatering",
        image: "/images/products/sludge-dewatering.png",
        shortDesc:
          "Efficient sludge dewatering systems to reduce sludge volume and disposal costs.",
        description:
          "Our sludge dewatering machines are designed to effectively separate solids from wastewater sludge, reducing sludge volume and improving handling efficiency. Sera Water offers reliable sludge dewatering solutions for ETP and STP plants serving chemical, textile, pharmaceutical and manufacturing industries.",
        applications: [
          "ETP & STP Plants",
          "Chemical Industry",
          "Textile Industry",
          "Pharmaceutical Industry",
        ],
        features: [
          "High solid-liquid separation efficiency",
          "Reduced sludge disposal cost",
          "Easy operation & maintenance",
          "Robust industrial construction",
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },
      {
        slug: "screw-pump",
        name: "Screw Pump",
        image: "/images/products/progressive-cavity-pump.png",
        shortDesc:
          "Positive displacement pumps designed for smooth and pulsation-free fluid transfer.",
        description:
          "Progressive cavity pumps are ideal for handling viscous, abrasive, and shear-sensitive fluids. These pumps ensure steady flow and are widely used in wastewater treatment, sludge handling, and industrial processing applications.",
        applications: [
          "Sludge Transfer",
          "Wastewater Treatment Plants",
          "Chemical Processing",
          "Industrial Slurry Handling",
        ],
        features: [
          "Low pulsation flow",
          "Handles high viscosity fluids",
          "Excellent suction capability",
          "Durable and low-maintenance design",
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },


      {
        slug: "tubesettler-media",
        name: "Tube Settler Media",
        image: "/images/products/tube-settler-media.jpg",
        shortDesc:
          "High-performance tube settler media for efficient sedimentation and clarification.",
        description:
          "Tube settler media are designed to enhance sedimentation efficiency by increasing settling surface area. Widely used in clarifiers and water treatment plants, they help reduce tank size requirements while improving solid-liquid separation.",
        applications: [
          "Water Treatment Plants",
          "Effluent Treatment Plants",
          "Clarifiers & Settling Tanks",
          "Industrial Wastewater Treatment",
        ],
        features: [
          "High settling efficiency",
          "Lightweight and durable structure",
          "Easy installation and maintenance",
          "Improves plant capacity",
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },


    ],
  },
  {
    category: "dosingpump-agitators",
    categoryName: "Dosing Pumps & Agitators",
    items: [
      {
        slug: "hydraulic-pump",
        name: "Hydraulic Pump",
        image: "/images/products/hydraulic-actuated-pump.png",
        shortDesc:
          "High-precision hydraulic diaphragm dosing pumps designed for accurate chemical dosing in industrial applications.",
        description:
          "Hydraulically actuated diaphragm pumps are designed for precise and leak-free dosing of chemicals in demanding industrial environments. These pumps offer excellent accuracy, high pressure handling, and long service life, making them ideal for chemical dosing in water and wastewater treatment plants.",
        applications: [
          "Water & Wastewater Treatment",
          "Chemical Processing Plants",
          "Power Plants",
          "Pharmaceutical Industry",
        ],
        features: [
          "High dosing accuracy",
          "Leak-proof diaphragm design",
          "Suitable for corrosive chemicals",
          "Long operational life",
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },

      {
        slug: "plunger-pump",
        name: "Plunger Pump",
        image: "/images/products/plunger-metering-pump.png",
        shortDesc:
          "Heavy-duty plunger metering pumps for high-pressure chemical dosing applications.",
        description:
          "Plunger metering pumps are designed for high-pressure and high-flow applications where precise chemical dosing is required. These pumps are widely used in industrial processes requiring consistent and accurate flow control.",
        applications: [
          "Chemical Processing",
          "Oil & Gas Industry",
          "Water Treatment Plants",
          "Industrial Manufacturing",
        ],
        features: [
          "High pressure capability",
          "Robust mechanical construction",
          "Accurate flow control",
          "Suitable for harsh operating conditions",
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },
      {
        slug: "mechanical-pump",
        name: "Mechanical Pump",
        image: "/images/products/mechanical-diaphragm-pump.png",
        shortDesc:
          "Reliable diaphragm dosing pumps for low to medium pressure applications.",
        description:
          "Mechanical diaphragm metering pumps are ideal for precise chemical dosing where moderate pressure and flow rates are required. They offer simple construction, easy maintenance, and long service life.",
        applications: [
          "Water Treatment Plants",
          "Chemical Dosing Systems",
          "Industrial Process Control",
        ],
        features: [
          "Simple and robust design",
          "Low maintenance cost",
          "Accurate chemical dosing",
          "Compact and durable construction",
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },
      {
        slug: "electronic-dosing-pump",
        name: "Electronic Dosing Pump",
        image: "/images/products/electronic-dosing-pump.png",
        shortDesc:
          "Electronically controlled dosing pumps for precise and automated chemical dosing.",
        description:
          "Electronic dosing pumps provide accurate and programmable chemical dosing for water treatment and industrial applications. These pumps support automation and integration with control systems for precise flow regulation.",
        applications: [
          "Water Treatment Systems",
          "Cooling Towers",
          "Chemical Dosing Applications",
          "Process Automation Systems",
        ],
        features: [
          "Digital control interface",
          "High dosing accuracy",
          "Energy efficient operation",
          "Easy integration with PLC/SCADA",
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },
      {
        slug: "industrial-agitator-mixer",
        name: "Industrial Agitator & Mixer",
        image: "/images/products/agitator-mixer.png",
        shortDesc:
          "High-performance industrial agitators and mixers designed for efficient mixing, blending, and agitation in water and wastewater treatment processes.",
        description:
          "Our industrial agitators and mixers are engineered to deliver uniform mixing and reliable performance in demanding industrial environments. These systems are widely used in water and wastewater treatment plants, chemical processing units, and industrial applications where consistent agitation and process stability are critical. Designed for durability, energy efficiency, and optimal mixing performance, our agitators ensure superior process control and operational reliability.",
        applications: [
          "Water & Wastewater Treatment Plants",
          "Effluent Treatment Plants (ETP)",
          "Sewage Treatment Plants (STP)",
          "Chemical & Process Industries",
          "Mixing and Homogenization Applications"
        ],
        features: [
          "High-efficiency mixing performance",
          "Robust and corrosion-resistant construction",
          "Energy-efficient motor and gearbox design",
          "Suitable for continuous and heavy-duty operation",
          "Customizable design for various tank sizes"
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },
      {
        slug: "dosing-system",
        name: "Dosing System",
        image: "/images/products/dosing-system.jpg",
        shortDesc:
          "High-precision dosing systems designed for accurate chemical dosing in water and wastewater treatment applications.",
        description:
          "Our dosing systems are engineered to deliver precise and consistent chemical dosing for water and wastewater treatment processes. These systems are widely used in ETP, STP, and industrial process applications to ensure optimal chemical balance, improved treatment efficiency, and safe operation. Designed for accuracy, durability, and ease of control, our dosing systems support a wide range of chemicals and flow requirements.",
        applications: [
          "Water Treatment Plants (WTP)",
          "Effluent Treatment Plants (ETP)",
          "Sewage Treatment Plants (STP)",
          "Chemical Dosing Applications",
          "Industrial Process Control"
        ],
        features: [
          "Accurate and consistent chemical dosing",
          "Compatible with various chemicals and fluids",
          "Easy operation and maintenance",
          "Corrosion-resistant construction",
          "Energy-efficient and reliable performance"
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },
    ],
  },
  {
    category: "filteration-equipments",
    categoryName: "Filteration Equipment",
    items: [
      {
        slug: "vessels",
        name: "RO Vessels",
        image: "/images/products/vessel.jpg",
        shortDesc:
          "High-pressure RO vessels designed for reliable membrane housing in water purification systems.",
        description:
          "RO vessels are pressure-resistant housings used to contain RO membranes in water treatment systems. Designed for durability and high performance, our RO vessels ensure safe operation under high pressure and consistent water purification for industrial and commercial applications.",
        applications: [
          "Reverse Osmosis Plants",
          "Water Purification Systems",
          "Industrial RO Systems",
          "Commercial Water Treatment Units",
        ],
        features: [
          "High pressure resistance",
          "Corrosion-resistant material",
          "Compatible with standard RO membranes",
          "Long operational life",
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },

      {
        slug: "pressure-tube",
        name: "Pressure Tube",
        image: "/images/products/pressure-tube.jpg",
        shortDesc:
          "Durable pressure tubes for safe and efficient RO membrane housing.",
        description:
          "Pressure tubes are designed to safely hold RO membranes under high pressure. Manufactured using high-grade composite materials, they ensure structural strength, leak-free performance, and long-term durability in RO plants.",
        applications: [
          "RO Water Treatment Plants",
          "Industrial Filtration Systems",
          "Desalination Units",
        ],
        features: [
          "High tensile strength",
          "Corrosion and chemical resistant",
          "Lightweight and durable design",
          "Long service life",
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },

      {
        slug: "float-switch",
        name: "Float Switch",
        image: "/images/products/float-switch.jpg",
        shortDesc:
          "Reliable float switches for automatic water level control.",
        description:
          "Float switches are used to control liquid levels in tanks and sumps. They automatically start or stop pumps based on water level, preventing overflow or dry running and ensuring safe system operation.",
        applications: [
          "Water Storage Tanks",
          "RO & STP Systems",
          "Sump Tanks",
          "Industrial Fluid Control",
        ],
        features: [
          "Accurate level detection",
          "Durable float construction",
          "Low maintenance",
          "Suitable for multiple liquids",
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },

      {
        slug: "pressure-guage",
        name: "Pressure Gauge",
        image: "/images/products/pressure-gauge.jpg",
        shortDesc:
          "Accurate pressure measurement instruments for water treatment systems.",
        description:
          "Pressure gauges are used to monitor system pressure in RO plants, pipelines, and filtration systems. They ensure safe operation by providing accurate real-time pressure readings.",
        applications: [
          "RO Plants",
          "Industrial Pipelines",
          "Water Filtration Systems",
        ],
        features: [
          "High measurement accuracy",
          "Clear dial display",
          "Robust construction",
          "Long operational life",
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },

      {
        slug: "multiport-valve",
        name: "Multiport Valve",
        image: "/images/products/multiport-valve.png ",
        shortDesc:
          "Multiport valves for filtration control and backwashing operations.",
        description:
          "Multiport valves are used in filtration systems to control flow direction during filtration, backwash, rinse, and other operations. They ensure efficient operation of sand and carbon filters.",
        applications: [
          "Water Filtration Plants",
          "Sand & Carbon Filters",
          "Swimming Pool Filtration Systems",
        ],
        features: [
          "Multiple operation modes",
          "Leak-proof design",
          "Smooth handle operation",
          "High durability",
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },

      {
        slug: "distribution-system",
        name: "Distribution System",
        image: "/images/products/distribution-system.jpg",
        shortDesc:
          "Efficient water distribution systems for uniform flow and pressure.",
        description:
          "Distribution systems ensure uniform water flow across filtration units and treatment zones. Designed for durability and efficiency, they help maintain consistent system performance.",
        applications: [
          "Water Treatment Plants",
          "Industrial Distribution Systems",
          "RO & STP Units",
        ],
        features: [
          "Uniform flow distribution",
          "High mechanical strength",
          "Easy installation",
          "Long operational life",
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },

      {
        slug: "sand",
        name: "Filter Sand",
        image: "/images/products/filtered-sand.jpg",
        shortDesc:
          "High-quality filter sand for effective removal of suspended solids.",
        description:
          "Filter sand is used in multimedia and pressure sand filters to remove suspended particles and turbidity from water. It plays a critical role in pre-treatment processes.",
        applications: [
          "Water Filtration Plants",
          "Effluent Treatment Plants",
          "Swimming Pool Filtration",
        ],
        features: [
          "High filtration efficiency",
          "Uniform particle size",
          "Long service life",
          "Low maintenance",
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },

      {
        slug: "carbon",
        name: "Activated Carbon",
        image: "/images/products/carbon.jpg",
        shortDesc:
          "High-quality activated carbon for odor, color, and chlorine removal.",
        description:
          "Activated carbon is widely used for removing organic contaminants, chlorine, odor, and color from water. It enhances water quality and protects downstream equipment in treatment systems.",
        applications: [
          "Drinking Water Treatment",
          "Industrial Water Purification",
          "Pre-treatment for RO Systems",
        ],
        features: [
          "High adsorption capacity",
          "Improves water taste and odor",
          "Chemical-resistant material",
          "Long-lasting performance",
        ],
        videoUrl: "https://youtu.be/kH5qls5MZJw?si=KBxRmsKxsxwsIkeu",
        brochure: "/brochures/slug.pdf",
      },
    ],
  }



];
